import { FullBrowseDepartmentFragment } from '../FullBrowseNavHierarchy.generated'
import { FlatDepartment } from '../types'

/**
 * Since departments can have multiple category levels, use this helper to flatten them into a single
 * department object that correlates back to the parent department.
 */
export default function constructFlatDepartments(
  browseDepartments: FullBrowseDepartmentFragment[]
) {
  let flattenedDepartments: FlatDepartment[] = []

  browseDepartments.forEach(departmentForNavigation => {
    let flatDepartment = {
      id: departmentForNavigation.id,
      slug: departmentForNavigation.slug
    }

    departmentForNavigation.navigations.forEach(nestedNavigations => {
      if (nestedNavigations.category) {
        flattenedDepartments.push({
          ...flatDepartment,
          referenceSlug: nestedNavigations.category.slug,
          displayName: nestedNavigations.category.pluralDisplayName,
          topLevelItems: nestedNavigations.topLevelItems
        })
      } else {
        flattenedDepartments.push({
          ...flatDepartment,
          referenceSlug: departmentForNavigation.slug,
          displayName: departmentForNavigation.displayName,
          topLevelItems: nestedNavigations.topLevelItems
        })
      }
    })
  })

  return flattenedDepartments
}
